import state from '@/state';

export default function (amount) {
  const locale = state.locale?.lang || navigator.language;
  return new Intl.NumberFormat(locale, {
      style: 'decimal',
      maximumFractionDigits: 2 // Adjust as needed
  }).format(amount);
}